import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AvatarList, Box, Button, Checkbox, FormikForm, H3, Icon, Popover, SubmitButton, TextAreaField, useField, } from '@a-type/ui';
import { withGame } from '@long-game/game-client';
import { useImperativeHandle, useRef, useTransition } from 'react';
import { PlayerAvatar } from '../players/PlayerAvatar.js';
import { PlayerName } from '../players/PlayerName.js';
import cls from './ChatForm.module.css';
export const ChatForm = withGame(function ChatForm({ gameSuite, timing, sceneId, position, toolsRef, autoFocus, onSent, ...props }) {
    const { latestRoundIndex } = gameSuite;
    const fieldRef = useRef(null);
    useImperativeHandle(toolsRef, () => ({
        focus: () => {
            fieldRef.current?.focus();
        },
    }));
    const [sending, startTransition] = useTransition();
    return (_jsx(Box, { col: true, ...props, children: _jsx(FormikForm, { initialValues: { text: '', recipientIds: [] }, onSubmit: (values, { resetForm, setSubmitting }) => {
                const roundIndex = timing === 'endgame'
                    ? -1
                    : timing === 'round'
                        ? latestRoundIndex
                        : undefined;
                setSubmitting(true);
                startTransition(async () => {
                    await gameSuite
                        .sendChat({
                        content: values.text,
                        position,
                        sceneId,
                        roundIndex,
                    })
                        .finally(() => {
                        setSubmitting(false);
                    });
                    resetForm();
                    onSent?.();
                });
            }, className: cls.form, children: (form) => (_jsxs(_Fragment, { children: [_jsx(TextAreaField, { name: "text", placeholder: "Say something...", autoSize: true, className: cls.textArea, textAreaClassName: "w-full", inputRef: fieldRef, autoFocus: autoFocus, onKeyDown: (ev) => {
                            if (ev.key === 'Enter' &&
                                !(ev.shiftKey || ev.ctrlKey || ev.metaKey)) {
                                ev.preventDefault();
                                form.handleSubmit();
                            }
                        } }), _jsxs(Box, { gap: true, p: "sm", items: "center", justify: "between", full: "width", children: [_jsx(Box, { gap: true, children: _jsx(RecipientsField, {}) }), _jsx(SubmitButton, { emphasis: "primary", loading: sending, children: _jsx(Icon, { name: "send" }) })] })] })) }) }));
});
const RecipientsField = withGame(function RecipientsField({ gameSuite }) {
    const [field, _, tools] = useField({
        name: 'recipientIds',
    });
    const selectedUsers = gameSuite.members.filter((u) => field.value.includes(u.id));
    return (_jsxs(Popover, { children: [_jsx(Popover.Trigger, { render: _jsx(Button, { emphasis: "ghost", size: "small", "aria-label": "Select recipients" }), children: selectedUsers.length > 0 ? (_jsx(AvatarList, { count: selectedUsers.length, children: selectedUsers.map(({ id }, index) => (_jsx(AvatarList.ItemRoot, { index: index, children: _jsx(PlayerAvatar, { playerId: id }) }, id))) })) : (_jsx(Icon, { name: "globe" })) }), _jsx(Popover.Content, { children: _jsxs(Box, { container: true, col: true, gap: true, children: [_jsx(H3, { children: "Select recipients" }), _jsxs(Box, { gap: true, items: "center", children: [_jsx(Checkbox, { checked: selectedUsers.length === 0, onCheckedChange: (checked) => {
                                        if (checked) {
                                            tools.setValue([]);
                                        }
                                    }, disabled: selectedUsers.length === 0 }), _jsx(Icon, { name: "globe", size: 24 }), "Everyone"] }), gameSuite.members.map(({ id }) => (_jsxs(Box, { gap: true, items: "center", children: [_jsx(Checkbox, { checked: field.value.includes(id), onCheckedChange: (checked) => {
                                        if (checked) {
                                            tools.setValue([...field.value, id]);
                                        }
                                        else {
                                            tools.setValue(field.value.filter((uId) => uId !== id));
                                        }
                                    } }), _jsx(PlayerAvatar, { playerId: id }), _jsx(PlayerName, { playerId: id })] }, id)))] }) })] }));
});
//# sourceMappingURL=ChatForm.js.map